export default __webpack_public_path__ + "static/media/grad2.b12d7f95.jpg";